<template>
  <FormulateForm
    :name="formName"
    v-model.lazy="formValues"
    @submit="submit"
    class="bg-gray-100 py-4 px-6 mb-8"
  >
    <h3 v-if="!edit" class="font-bold text-xl mb-4">
      Add new parameter
    </h3>

    <div class="flex">
      <div class="w-1/2">
        <FormulateInput
          name="name"
          type="text"
          label="Name"
          placeholder="Name"
          validation="required"
        />
        <FormulateInput name="is_mandatory" type="checkbox" label="Mandatory" />
        <FormulateInput
          name="ui_input"
          type="select"
          :options="{
            text: 'Text',
            date: 'Date',
            select: 'Select',
            radio: 'Radio',
          }"
          label="Type"
          placeholder="Type"
          validation="required"
          validation-name="Type"
        />
      </div>
      <div class="w-1/2 pl-8">
        <FormulateInput
          v-if="hasOptions"
          name="white_list"
          type="group"
          label="Options"
          :repeatable="true"
          validation-name="options"
          validation="min:2,length"
          add-label="+ Option"
          #default="{index}"
        >
          <div class="flex items-start">
            <FormulateInput
              name="value"
              type="text"
              validation="required"
              class="flex-1"
            />
            <div class="h-10 mb-2">
              <base-button
                @click="toggleValueAdvancedForm(index)"
                type="button"
                class="h-full"
              >
                <icon-close
                  title="Close"
                  v-if="openAdvancedOptions.includes(index)"
                />
                <icon-cog title="Advanced" v-else />
              </base-button>
            </div>
          </div>
          <div
            v-if="openAdvancedOptions.includes(index)"
            class="px-3 py-2 bg-gray-200 mb-4"
          >
            <div class="mb-4">
              <FormulateInput
                name="prefix"
                type="text"
                help="If this option was selected the prefix will be used in the final tracking link"
                label="Tracking link prefix"
              />
            </div>
            <FormulateInput
              name="tracking_param"
              type="text"
              help="If this option was selected the tracking parameter will be used for the final tracking link"
              label="Tracking parameter"
            />
          </div>
        </FormulateInput>

        <div v-if="canHaveRegex" class="flex items-center">
          <FormulateInput
            name="regex_pattern"
            type="text"
            label="Validation RegEx"
            class="flex-1"
          />
          <base-tooltip
            text="RegEx knowledge base"
            side="left"
            class="mb-2 ml-4 py-1"
          >
            <a
              href="https://regexr.com/"
              target="_blank"
              class="block w-8 h-8 py-2 bg-blue-400 rounded-full text-center text-white font-bold font-mono"
            >
              <icon-external />
            </a>
          </base-tooltip>
        </div>
        <div v-if="usesRegex" class="border-l-4 border-gray-400 pl-4">
          <FormulateInput
            name="regex_hint"
            type="text"
            label="RegEx help message"
          />
          <FormulateInput
            name="regex_message"
            type="text"
            label="RegEx error message"
          />
        </div>
      </div>
    </div>

    <FormulateErrors />

    <base-button type="submit" class="mt-6" :loading="sending">
      {{ edit ? 'Save' : 'Add Parameter' }}
    </base-button>
  </FormulateForm>
</template>

<script>
import { mapState } from 'vuex';

export default {
  props: {
    schema: Object,
  },
  data() {
    return {
      formName: `schemaForm${this.segment ? this.segment.id : ''}`,
      formValues: this.schema ? JSON.parse(JSON.stringify(this.schema)) : {},
      sending: false,
      openAdvancedOptions: [],
    };
  },
  computed: {
    ...mapState({
      currentCompanyId: (state) => state.company.currentId,
    }),
    edit() {
      return Boolean(this.schema);
    },
    hasOptions() {
      return ['select', 'radio'].includes(this.formValues.ui_input);
    },
    canHaveRegex() {
      return ['text'].includes(this.formValues.ui_input);
    },
    usesRegex() {
      return Boolean(this.formValues.regex_pattern);
    },
  },
  methods: {
    toggleValueAdvancedForm(index) {
      if (this.openAdvancedOptions.includes(index)) {
        this.openAdvancedOptions = this.openAdvancedOptions.filter(
          (i) => i !== index
        );
      } else {
        this.openAdvancedOptions.push(index);
      }
    },
    async submit(data) {
      try {
        this.$formulate.resetValidation(this.formName);
        this.sending = true;
        const action = this.edit ? 'updateSchema' : 'addSchema';
        await this.$store.dispatch(`company/schema/${action}`, data);
        this.$emit('saved');
      } catch (error) {
        this.$formulate.handle(error, this.formName);
      } finally {
        this.sending = false;
      }
    },
  },
};
</script>
